export const version = "properties/5.0.7";
//# sourceMappingURL=_version.js.map